<template>
  <card-block>
    <spinner-block v-model="dataProgress">
      <div v-if="data">
        <card-header>
          <template v-if="id">
            <router-link :to="{name: 'faq.detail', params: {id: id}}">Вопрос</router-link><!-- -->:
            редактирование

          </template>
          <template v-else>
            <router-link :to="{name: 'faq.list'}">Вопросы</router-link><!-- -->:
            создание
          </template>


        </card-header>
        <card-body>

          <gui-checkbox v-model="data.is_active" :error="dataError.is_active" label="Активный"/>
          <gui-textarea autosize v-model="data.question" :error="dataError.question"
                        label="Вопрос"/>
          <gui-textarea autosize v-model="data.answer" :error="dataError.answer"
                        label="Ответ"/>
          <gui-input v-model="data.sort" :error="dataError.sort" label="Сортировка"/>
          <gui-application-multi-select v-model="data.application_ids" :error="dataError.application_ids"
                                        label="Приложения"/>

          <div class="mt-5">
            <button-save v-if="!data.id" @click="add()"/>
            <button-save v-else @click="save"/>
            <button-back/>
          </div>
        </card-body>
      </div>
    </spinner-block>
  </card-block>
</template>

<script>


import GuiApplicationMultiSelect from "@/components/Widget/GuiApplicationMultiSelect";

export default {
  components: {GuiApplicationMultiSelect},
  data() {
    return {
      data: null,
      dataDefault: {
        question: '',
        answer: '',
        is_active: '',
        sort: '',
        application_ids: [],
      },
      dataError: {
        question: '',
        answer: '',
        is_active: '',
        sort: '',
        application_ids: '',
      },
      dataProgress: false,
    }
  },
  computed: {
    id() {
      return this.$route.params.id
    }
  },
  mounted() {
    this.init()
  },
  methods: {

    init() {
      if (this.id) {
        this.data = null
        this.loadData()
      } else {
        this.data = _.clone(this.dataDefault)
      }
    },
    loadData() {
      axiosGetValue('/api/admin/faq/get', {id: this.id}, e => {
        this.data = e
        this.data.role_ids = e.roles.map(e => e.id)
      }, e => this.dataProgress = e)
    },

    save() {
      axiosFast({
        url: route('/api/admin/faq/update'),
        data: {data: this.data, id: this.data.id},
        error: this.dataError,
        progress: e => this.dataProgress = e,
        result: () => {
          toastSuccess('Данные сохранены');
          this.$router.push({name: 'faq.detail', params: {id: this.data.id}})
        },
      })
    },
    add() {
      axiosFast({
        url: route('/api/admin/faq/create'),
        data: {data: this.data},
        error: this.dataError,
        progress: e => this.dataProgress = e,
        result: (data) => {
          toastSuccess('Данные добавлены');
          this.$router.push({name: 'faq.detail', params: {id: data.id}})
        },
      })
    },
  },
}
</script>